import { makeStyles } from '@material-ui/core/styles';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  customTabs: {
    color: themeColor.defaultTextColor,
    maxWidth: '64.8vw',
    width: '100%',
    minHeight: 40,
  },
  scrollButton: {
    width: '4.09vw',
  },
}));
